import {FeedbackCreateDto, fetchFeedbackCreate} from '@blesk-frontend/api';
import {Button, Modal, ModalProps, Textarea} from '@blesk-frontend/ui';
import {useForm} from 'react-hook-form';
import {toast} from 'sonner';

export const FeedbackModal = (props: ModalProps) => {
  const {
    register,
    handleSubmit,
    formState: {isSubmitting, isSubmitSuccessful},
  } = useForm<FeedbackCreateDto>();

  const onSubmit = handleSubmit(async (data) => {
    await fetchFeedbackCreate(data);
    toast.success('Спасибо, сообщение отправлено');
    props.onClose?.();
  });

  return (
    <Modal {...props}>
      <form className="flex flex-col gap-6" onSubmit={onSubmit}>
        <h1 className="text-title-h1">Обратная связь</h1>

        <p className="text-paragraph-md text-text-primary">
          Напишите нам, если столкнулись с технической проблемой, есть вопрос или предложение. Мы
          <br />
          читаем каждое сообщение и быстро реагируем.
        </p>

        <div className="flex flex-col gap-2">
          <Textarea
            {...register('message', {
              required: 'Обязательное поле',
              minLength: {value: 5, message: 'Минимум 5 символов'},
            })}
            placeholder="Напишите отзыв"
            className="h-auto max-h-96 resize-y"
          />

          <p className="text-sm text-text-secondary">
            Ответим на адрес, указанный при регистрации.
          </p>
        </div>

        <Button className="w-fit" type="submit" loading={isSubmitting || isSubmitSuccessful}>
          Отправить
        </Button>
      </form>
    </Modal>
  );
};
